const addOrRemove = (array, element) => {
  if (!array.length || !array[0]) {
    return [element];
  }

  return array.includes(element) ? array.filter((item) => item !== element) : [...array, element];
};

export default addOrRemove;
